import { render, staticRenderFns } from "./LogByUser.vue?vue&type=template&id=96672bb4"
import script from "./LogByUser.vue?vue&type=script&lang=js"
export * from "./LogByUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96672bb4')) {
      api.createRecord('96672bb4', component.options)
    } else {
      api.reload('96672bb4', component.options)
    }
    module.hot.accept("./LogByUser.vue?vue&type=template&id=96672bb4", function () {
      api.rerender('96672bb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LogByUser.vue"
export default component.exports